export default {
  name: 'editableCellInput',
  props: ['text', "align", "slotName", "errStatus"],
  /* props: {
  	text: {},
  	align:String,
  	slotName:String,
  	errStatus:{}
  }, */
  data: function data() {
    return {
      value: this.text,
      err: this.errStatus
    };
  },
  watch: {
    text: function text() {
      this.value = this.text;
      console.log(this.text);
      console.log(this.value);
    },
    errStatus: function errStatus() {
      this.err = this.errStatus;
    }
  },
  mounted: function mounted() {
    console.log(this.align);
  },
  methods: {
    handleChange: function handleChange(e) {
      var value = e;
      this.value = value;
      if (this.slotName == "productNo" || this.slotName == "productChannelid" || this.slotName == "productStocknum") {
        if (this.slotName == "productStocknum") {
          if (this.value || this.value == 0) {
            this.err = false;
            //不能直接修改父组件传过来的值
            // this.errStatus = false
          } else {
            this.err = true;
            // this.errStatus = true
          }
        } else {
          if (this.value) {
            this.err = false;
            //不能直接修改父组件传过来的值
            // this.errStatus = false
          } else {
            this.err = true;
            // this.errStatus = true
          }
        }
      }
      this.check();
    },
    check: function check() {
      var obj = {
        value: this.value,
        errStatus: this.err
      };
      this.$emit('change', obj);
    }
  }
};